export default __webpack_public_path__ + "img/20.6b495ffd.jpg";